import styled from 'styled-components';

export const HTMLConteudoPublicacao = styled.div`
  && {
    * {
      font-family: var(--font-quicksand);
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: #000000;
    }

    width: 100%;

    @media (min-width: 1200px) {
      padding: 30px;
    }

    h1 {
      font-size: 38px;
      line-height: 40px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    h2 {
      font-size: 28px;
      line-height: 32px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 22px;
      line-height: 24px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    b {
      font-weight: 600;
      color: #000000;
    }

    strong {
      font-weight: 600;
    }

    a {
      color: ${({ theme }) => theme.colors.accent.accent[9]};
      font-weight: 600;

      * {
        color: inherit;
        font-weight: inherit;
      }
    }
    #link {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 16px;
    }

    p {
      margin-bottom: 10px;

      span {
        width: 100% !important;
        margin-bottom: 20px;
      }
    }

    iframe {
      width: 100%;
    }

    iframe,
    img {
      margin-top: 20px;
      max-width: 100%;
    }
  }
`;
